fragment plannedBreakInfo on PlannedBreak {
  id
  name
  startTime
  endTime
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
  lines {
    id
    name
  }
}
